import { memo } from 'react';
import { TextField as MuiTextField, type Props as TextFieldProps } from './TextField';
import { IconButton, InputAdornment, styled } from '@mui/material';
import { Icon, type IconNames } from './Icon';
import ClearIcon from '@mui/icons-material/Clear';

const TextField = styled(MuiTextField)<{ disabled?: boolean }>(({ theme, disabled }) => ({
  '& .MuiOutlinedInput-root': {
    background: disabled ? theme.palette.grey[200] : 'default',
  },
}));

interface Props extends TextFieldProps {
  icon?: IconNames;
  disabled?: boolean;
  onClear?: () => void;
}

export const LookupInput = memo(({ icon, disabled = false, onClear, ...rest }: Props) => {
  const showClear = Boolean(onClear && rest.value);

  return (
    <TextField
      disabled={disabled}
      {...rest}
      slotProps={{
        input:
          icon || showClear
            ? {
                endAdornment: (
                  <InputAdornment position="end">
                    {showClear && (
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          onClear?.();
                        }}>
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    )}
                    {icon && <Icon size="small" icon={icon} />}
                  </InputAdornment>
                ),
                readOnly: true,
              }
            : {},
      }}
      background="white"
    />
  );
});
